export const compareOptionList = [
  { value: '<', text: '< Less than' },
  { value: '<=', text: '≤ Less than or equal' },
  { value: '>', text: '> Greater than' },
  { value: '>=', text: '≥ Greater than or equal to' },
  { value: '=', text: ' = Equal to' },
];

export const compareStepMap: any = {
  '<': '<',
  '<=': '≤',
  '>': '>',
  '>=': '≥',
  '=': '=',
};
